// utils/catalogueHelpers.js
import { getSafeDomain } from './domainUtils';

// getStatusColor è stato spostato in CatalogStatusConfig.js per una gestione centralizzata

export const getQrCodeUrl = (catalogue) => {
    if (catalogue.webUrl) {
        return catalogue.webUrl.startsWith('http')
            ? catalogue.webUrl
            : `https://${catalogue.webUrl}`;
    }

    const safeDomain = getSafeDomain(catalogue.domain) || 'arshades.it';
    return `https://${safeDomain}/${catalogue.id}`;
};

export const getStatCards = (catalogueStats, catalogue) => {
    const stats = catalogueStats[catalogue.id] || { mainAssets: 0, brands: 0, sku: 0 };
    return [
        { value: stats.brands, label: 'Brands' },
        { value: stats.mainAssets, label: 'Main Assets' },
        { value: stats.sku, label: 'SKU' }
    ];
};

export const handleDownloadQrCode = (catalogue) => {
    const canvas = document.getElementById(`qr-code-${catalogue.id}`);
    if (canvas) {
        const url = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = url;
        link.download = `qrcode-${catalogue.nameCatalog || 'catalogue'}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};